import { Route } from 'react-router-dom';
import { CreateAdvancePage } from './create-advance';
import { EditAdvancePage } from './edit-advance';
import { ListAdvancesPage } from './list-advances';
import { ViewAdvancePage } from './view-advance';
import { RequireAuth } from '/src/components';

export { CreateAdvancePage, EditAdvancePage, ListAdvancesPage, ViewAdvancePage };

export const advancesRoutes: React.ReactElement[] = [
  // Create
  <Route
    path="/advances/create"
    element={
      <RequireAuth>
        <CreateAdvancePage />
      </RequireAuth>
    }
  />,

  // Edit
  <Route
    path="/advances/:advanceId/edit"
    element={
      <RequireAuth>
        <EditAdvancePage />
      </RequireAuth>
    }
  />,

  // List
  <Route
    path="/advances"
    element={
      <RequireAuth>
        <ListAdvancesPage />
      </RequireAuth>
    }
  />,

  // View
  <Route
    path="/advances/:advanceId"
    element={
      <RequireAuth>
        <ViewAdvancePage />
      </RequireAuth>
    }
  />,
];
